import {Button} from "../../../../index";
import React from "react";
import {useViewerStore} from "../../../../../store/store";

interface FinaliseConfirmationPopupProps {
    certification_status: string;
    confirm: () => void;
}

const CertificationValidation = (props: FinaliseConfirmationPopupProps) => {

    const sceneViewer = useViewerStore(state => state.sceneViewer);


    const cancelFinalize = () => {
        sceneViewer.viewerAlert({show: false})
    }


    return (
        <>

            <p>This design has
                been {props.certification_status.slice(0, props.certification_status.lastIndexOf(" "))} certified.
                Changes to this<br/> made will disable the
                {" " + props.certification_status.slice(0, props.certification_status.lastIndexOf(" "))} certification
                from this design
                <br/>and will flag this as a "Certified Design Override".
                <br/>
            </p>
            <p>
                Press "Confirm" to continue finalizing this design or "Cancel"<br/> to go back.
            </p>
            <br/>
            <div className={"modal-bottom-action-button-container"}>

                <Button
                    variant="btn-primary"
                    size="btn-md"
                    className="editor__control--finalize modal-confirm-button"
                    onClick={props.confirm}
                >
                    Confirm
                </Button>
                <Button
                    variant="btn-primary"
                    size="btn-md"
                    className="editor__control--finalize modal-cancel-button"
                    onClick={cancelFinalize}
                >
                    Cancel
                </Button>

            </div>
        </>
    )
}

export default CertificationValidation;